import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/stock-diamant.service';



export const listStockDiamant = createAsyncThunk(
    "StockDiamant/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const filterStockDiamant = createAsyncThunk(
    "StockDiamant/adm-list-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const searchByCodeStockDiamant = createAsyncThunk(
    "StockDiamant/search-by-code",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.searchByCode(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewStockDiamant = createAsyncThunk(
    "StockDiamant/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createStockDiamant = createAsyncThunk(
    "StockDiamant/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const createManyStockDiamant = createAsyncThunk(
    "StockDiamant/adm-create-bulk",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createMany(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateStockDiamant = createAsyncThunk(
    "StockDiamant/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteStockDiamant = createAsyncThunk(
    "StockDiamant/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listOpenDiamantAlerts = createAsyncThunk(
    "StockDiamant/adm-listOpenAlerts",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listOpenAlerts(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listFBOpenDiamantAlerts = createAsyncThunk(
    "StockDiamant/adm-listFbOpenAlerts",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listFbOpenAlerts(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listCloseDiamantAlerts = createAsyncThunk(
    "StockDiamant/adm-listCloseAlerts",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listCloseAlerts(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listAllocationDiamant = createAsyncThunk(
    "StockDiamant/adm-listAllocationDiamant",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listAllocationDiamant(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateDiamantAlert = createAsyncThunk(
    "StockDiamant/adm-updateAlert",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateAlert(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createInventaireDiamant = createAsyncThunk(
    "StockDiamant/adm-createInventaire",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createInventaire(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const validateInventaireDiamant = createAsyncThunk(
    "StockDiamant/adm-validateInventaire",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.validateInventaire(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listInventaireDiamant = createAsyncThunk(
    "StockDiamant/adm-listInventaire",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listInventaire(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listViewInventaireDiamant = createAsyncThunk(
    "StockDiamant/adm-viewInventaire",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewInventaire(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const updateInventaireDiamant = createAsyncThunk(
    "StockDiamant/adm-updateInventaire",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateInventaire(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_StockDiamant: null
}

const StockDiamantSlice = createSlice({
    name: "StockDiamant",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = StockDiamantSlice;
export const { clear } = StockDiamantSlice.actions;
export default reducer;